// @ vendors
const React = require('react');
require('./hireCardOpenCreditStepINE.scss');

// @ helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
const getExtension = require('utilities/mimeTypeToExt');
// @ components
const { LoadingSection } = require('commonsComponents/loadingSection');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
const { OKPdfViewer } = require('commonsComponents/OKPdfViewer');
import { OKCheckbox } from 'commonsComponents/OKCheckbox';
const { downloadAsFile, base64ToBlob } = require('utilities/APIRequestHelper');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');

// @ constants
const FILENAMES = require('constants/mortgageRequestFileNames');
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');


class HireCardOpenCreditStepINE extends React.Component {
    constructor(props) {
        super(props);
        this.handleAgreeCheckModal = this.handleAgreeCheckModal.bind(this);
        this.handleDownloadPdf = this.handleDownloadPdf.bind(this);
        this.handleOnPrint = this.handleOnPrint.bind(this);
        this.handleDocumentReaded = this.handleDocumentReaded.bind(this);
        this.handleYesNoSignedDocuments = this.handleYesNoSignedDocuments.bind(this)


    }

    buildTitle() {
        return <FormattedText value="hireCardOpenCreditStepINE-titlePage" />;
    }
    subtitleLink() {
        return <FormattedText value="hireCardOpenCreditStepINE-subtitlePage" />;
    }
    blockInfo() {
        return (
            <BlockInfo extraClass="contract-payroll-loan-step-two__block-check" hasCheckbox>
                <FormattedText value="hireCardOpenCreditStepINE-blockInfoOficine" />
            </BlockInfo>
        );
    }
    handleDocumentReaded() {
        const { cardsConfimationScrollDown } = this.props;
        cardsConfimationScrollDown();
    }

    handleDownloadPdf() {
        const { documentINE, documentDownloadName } = this.props;
        const base64 = documentINE;
        const contentType = "application/pdf";
        const pdf = `data:${contentType};base64,${base64}`;
        let fileName = documentDownloadName ? formatText(documentDownloadName) + "." + getExtension(contentType) : formatText(`hireCardOpenCreditStepINE-pdfDownload`) + "." + getExtension(contentType);
        downloadAsFile(base64ToBlob(pdf), contentType, fileName);

    }
    handleAgreeCheckModal() {
        const { checkCheckedDocument } = this.props;
        checkCheckedDocument()
    }
    handleYesNoSignedDocuments(value) {
        const { printedAndSignedRadioChanged, enableButtonOffice, checkRadioButton } = this.props

        checkRadioButton(value === 'yes' ? true : false)
        printedAndSignedRadioChanged(value)
        enableButtonOffice();
    }
    handleOnPrint() {
        const { documentINE, hireCardOpenCreditprintDocument } = this.props;
        if (documentINE) {
            const base64 = documentINE;
            const contentType = "application/pdf";
            const pdf = `data:${contentType};base64,${base64}`;
            const data = [base64ToBlob(pdf)];
            const blobObject = new Blob(data, { type: `${contentType};base64` });
            const blobURL = URL.createObjectURL(blobObject);
            const winparams = `dependent=yes,locationbar=no,scrollbaars=yes,menubar=yes,resizable,screenX=50,screenY=50,width=${screen.width},height=${screen.height}`;
            const printWindow = window.open(blobURL, '', winparams);
            hireCardOpenCreditprintDocument()
            if (printWindow) {
                printWindow.print();
            }

        }
    }
    buildViewer() {
        const { documentINE } = this.props;
        if (documentINE) {
            let title = formatText(`hireCardOpenCreditStepINE-titlePdf`);
            const scale = 1.05;
            const viewerHeight = 480;
            const base64 = documentINE;
            const contentType = "application/pdf";
            const document = `data:${contentType};base64,${base64}`;

            return (
                <OKPdfViewer
                    onDownload={this.handleDownloadPdf}
                    pdfFile={document}
                    scale={scale}
                    viewerHeight={viewerHeight}
                    onPrint={this.handleOnPrint}
                    title={title}
                    showScroll
                    onScroll={this.handleOnScroll}
                    onDocumentReaded={this.handleDocumentReaded}
                />
            );
        } else {
            return <LoadingSection />;
        }
    }
    buildCheckbox() {
        const {
            agreeIneCheckbox
        } = this.props;
        const errorMessage = formatText('contractEasyLoanStepThree-checkboxErrorMessage');
        const labelCheckbox = 'hireCardOpenCreditStepINE-labelCheckbox';

        return (
            <div>

                <OKCheckbox
                    extraClass="contract-loan-pdf-viewer__checkbox"
                    errorMessage={errorMessage}
                    idName="contract-loan-pdf-viewer-checkbox"
                    label={<FormattedText value={labelCheckbox} />}
                    onChange={this.handleAgreeCheckModal}
                    value={agreeIneCheckbox}
                />
            </div>
        )

    }
    buildRadioButton() {

        const { printDocument, documentsPrintedAndSigned } = this.props;
        return (
            <div className="mortgage-request-holder-radio-button">
                {printDocument ?
                    <>
                        <p>{formatText(`hireCardtStep-titleOfficeRadio`)}</p>
                        <RadioButtonGroup
                            onChange={this.handleYesNoSignedDocuments}
                            selectedValue={documentsPrintedAndSigned === undefined ? '' : (documentsPrintedAndSigned ? 'yes' : 'no')}
                            idPrefix="radioPrintedDocument"
                            isHorizontal={false}
                            name="radioPrintedDocument">
                            <RadioButton label={formatText('officePrinter-yesRadioOption')} value={'yes'} className="signature-pattern__printed-documents-radio" />
                            <RadioButton label={formatText('officePrinter-noRadioOption')} value={'no'} className="signature-pattern__printed-documents-radio" />
                        </RadioButtonGroup>
                        {documentsPrintedAndSigned === false && (
                            <p className="signature-pattern__printed-documents-radio no-select" >{formatText(`hireCardOpenCreditStepINE-radioButtonNotSelected`)}</p>
                        )}
                    </>
                    : null
                }
            </div>
        )

    }
    render() {
        const { scrollDown } = this.props;
        const title = this.buildTitle();
        const subtitleLink = this.subtitleLink();
        const blockInfo = isPrintOfficeMode() ? this.blockInfo() : null;
        const PDFDcocument = this.buildViewer();
        const checkbox = scrollDown && !isPrintOfficeMode() && this.buildCheckbox();
        const buttonRadioGroup = isPrintOfficeMode() && this.buildRadioButton();
        return (
            <>
                <div className="mortgage-request-holder-confirmation__title">
                    {title}
                </div>
                <div className="mortgage-request-holder-confirmation__subtitle">
                    {subtitleLink}
                </div>
                {isPrintOfficeMode() ?
                    <div className="mortgage-request-holder-confirmation__subtitle">
                        {blockInfo}
                    </div>
                    : null}
                <div className="mortgage-request-holder-confirmation__document-link">
                    {PDFDcocument}
                </div>
                <div className="mortgage-request-holder-pdf-file">
                    {checkbox}
                </div>
                {buttonRadioGroup}
            </>
        )
    }
}



module.exports = HireCardOpenCreditStepINE;